// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ilME","newExpiryDate":"styles_newExpiryDate__1shdP","footer":"styles_footer__1Uets"};